import { Fragment as y, defineComponent as v, mergeProps as C, cloneVNode as _, ref as u, openBlock as c, createBlock as d, resolveDynamicComponent as k, withCtx as m, renderSlot as h, unref as P } from "vue";
const g = (r) => r ? r.flatMap((t) => t.type === y ? g(t.children) : [t]) : [], S = v({
  name: "AdsPrimitiveSlot",
  inheritAttrs: !1,
  setup(r, { attrs: t, slots: o }) {
    return () => {
      var f, p;
      if (!o.default)
        return;
      const s = g(o.default()), [e, ...a] = s;
      if (Object.keys(t).length > 0) {
        (f = e.props) == null || delete f.ref;
        const l = C(t, e.props ?? {});
        t.class && ((p = e.props) != null && p.class) && delete e.props.class;
        const n = _(e, l);
        for (const i in l)
          i.startsWith("on") && (n.props || (n.props = {}), n.props[i] = l[i]);
        return s.length === 1 ? n : [n, ...a];
      }
      return s;
    };
  }
}), A = /* @__PURE__ */ v({
  name: "AdsPrimitive",
  __name: "index",
  props: {
    asChild: { type: Boolean, default: !1 },
    as: { default: "div" }
  },
  setup(r, { expose: t }) {
    const o = u(r.asChild ? "template" : r.as), s = u();
    return t({
      focus: (e) => {
        var a;
        (a = s.value) == null || a.focus(e);
      }
    }), (e, a) => o.value !== "template" ? (c(), d(k(o.value), {
      key: 0,
      ref_key: "el",
      ref: s,
      class: "ads-reset-css"
    }, {
      default: m(() => [
        h(e.$slots, "default")
      ]),
      _: 3
    }, 512)) : (c(), d(P(S), { key: 1 }, {
      default: m(() => [
        h(e.$slots, "default")
      ]),
      _: 3
    }));
  }
});
export {
  S as P,
  A as _,
  g as r
};
